import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../helpers/role_helper";
import { getLoggedinUser } from "../api";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isSellerProducts, setIsSellerProducts] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  //Calender
  const [isCalender, setCalender] = useState(false);

  // Apps
  const [isEmail, setEmail] = useState(false);
  const [isSubEmail, setSubEmail] = useState(false);
  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isProjects, setIsProjects] = useState(false);
  const [isTasks, setIsTasks] = useState(false);
  const [isCRM, setIsCRM] = useState(false);
  const [isCrypto, setIsCrypto] = useState(false);
  const [isInvoices, setIsInvoices] = useState(false);
  const [isSupportTickets, setIsSupportTickets] = useState(false);
  const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);
  const [isJobs, setIsJobs] = useState(false);
  const [isJobList, setIsJobList] = useState(false);
  const [isCandidateList, setIsCandidateList] = useState(false);
  const [isWebsite, setIsWebsite] = useState(false);

  // Authentication
  const [isSignIn, setIsSignIn] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isPasswordCreate, setIsPasswordCreate] = useState(false);
  const [isLockScreen, setIsLockScreen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [isSuccessMessage, setIsSuccessMessage] = useState(false);
  const [isVerification, setIsVerification] = useState(false);
  const [isError, setIsError] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);
  const [isLanding, setIsLanding] = useState(false);
  const [isBlog, setIsBlog] = useState(false);

  // Charts
  const [isApex, setIsApex] = useState(false);

  // Multi Level
  const [isLevel1, setIsLevel1] = useState(false);
  const [isLevel2, setIsLevel2] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  // Get user role for menu filtering
  const userProfile = getLoggedinUser();
  const userRole = getUserRole(userProfile);

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "SellerProducts") {
      setIsSellerProducts(false);
    }
    if (iscurrentState !== "Website") {
      setIsWebsite(false);
    }
    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isApps,
    isSellerProducts,
    isWebsite,
    isSettings,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
  ]);

  // Filter menu items based on user role
  const getFilteredMenuItems = () => {
    // Base menu items - always shown
    const allMenuItems = [
      {
        label: "Menu",
        isHeader: true,
      },
      {
        id: "ecommerce",
        label: "Dashboard",
        icon: "ri-dashboard-2-line",
        link: userRole === "seller" ? "/seller/dashboard" : "/dashboard",
      },

    ];

    // If user is not logged in or role is not determined, return empty menu
    if (!userRole) {
      return allMenuItems;
    }

    // Admin menu items
    if (userRole === "admin") {
      allMenuItems.push(
        {
          id: "apps",
          label: "Products",
          icon: "ri-apps-2-line",
          link: "/#",
          click: function (e) {
            e.preventDefault();
            setIsApps(!isApps);
            setIscurrentState("Apps");
            updateIconSidebar(e);
          },
          stateVariables: isApps,
          subItems: [
            {
              id: 1,
              label: "Products",
              link: "/products",
              parentId: "apps",
            },
            {
              id: "category",
              label: "Category",
              icon: " ri-file-list-3-line",
              link: "/products/category",
            },
            {
              id: "subcategory",
              label: "Subcategory",
              icon: " ri-file-list-3-line",
              link: "/products/sub-category",
            },
            {
              id: "Attribute",
              label: "Attribute",
              icon: " ri-file-list-3-line",
              link: "/products/attribute",
            },
            {
              id: 5,
              label: "Orders",
              link: "/orders",
              icon: " ri-file-list-3-line",
            },
            {
              id: 8,
              label: "Invoices",
              icon: " ri-file-list-3-line",
              link: "/invoices",
            },
          ],
        },
        {
          id: "customers",
          label: "Customers",
          icon: "ri-user-line",
          link: "/customers",
        },
        {
          id: "website",
          label: "Website",
          icon: "ri-global-line",
          link: "/#",
          click: function (e) {
            e.preventDefault();
            setIsWebsite(!isWebsite);
            setIscurrentState("Website");
            updateIconSidebar(e);
          },
          stateVariables: isWebsite,
          subItems: [
            {
              id: "home-banner",
              label: "Home Banner",
              icon: "ri-image-line",
              link: "/website/home-banner",
            },
            {
              id: "home-ad-banner",
              label: "Home Ad Space",
              icon: "ri-advertisement-line",
              link: "/website/home-ad-banner",
            },
            {
              id: "best-selling-ad",
              label: "Best Selling Ad",
              icon: "ri-thumb-up-line",
              link: "/website/best-selling-ad",
            },
            {
              id: "footer-ad",
              label: "Footer Ad",
              icon: "ri-image-add-line",
              link: "/website/footer-ad",
            },
            {
              id: "stripe-settings",
              label: "Stripe Settings",
              icon: "ri-bank-card-line",
              link: "/website/stripe-settings",
            },
          ],
        },
        {
          id: "sellerproducts",
          label: "Seller Products",
          icon: "ri-store-2-line",
          link: "/#",
          click: function (e) {
            e.preventDefault();
            setIsSellerProducts(!isSellerProducts);
            setIscurrentState("SellerProducts");
            updateIconSidebar(e);
          },
          stateVariables: isSellerProducts,
          subItems: [
            {
              id: 1,
              label: "Products",
              link: "/seller-products",
              parentId: "sellerproducts",
            },

            {
              id: "Category",
              label: "Category",
              icon: " ri-file-list-3-line",
              link: "/products/category",
            },
            {
              id: "Subcategory",
              label: "Subcategory",
              icon: " ri-file-list-3-line",
              link: "/products/sub-category",
            },
            {
              id: "orders",
              label: "Orders",
              link: "/apps-ecommerce-orders",
              icon: " ri-file-list-3-line",
            },
            {
              id: "invoices",
              label: "Invoices",
              icon: " ri-file-list-3-line",
              link: "/invoices",
            },
            {
              id: "withdrawal",
              label: "Withdrawal",
              icon: " ri-file-list-3-line",
              link: "/vendor-withdraw",
            },
            {
              id: "Product Review",
              label: "Product Review",
              icon: " ri-file-list-3-line",
              link: "/product-review",
            },
          ],
        },
        {
          label: "Settings",
          isHeader: true,
        },

        {
          id: "settings",
          label: "Business Settings",
          icon: "ri-store-2-line",
          link: "/#",
          click: function (e) {
            e.preventDefault();
            setIsSettings(!isSettings);
            setIscurrentState("Settings");
            updateIconSidebar(e);
          },
          stateVariables: isSettings,
          subItems: [
            {
              id: 1,
              label: "VAT & TAX",
              link: "/taxes",
              parentId: "Settings",
            },
            // {
            //   id: "Business Setup",
            //   label: "Business Setup",
            //   icon: " ri-file-list-3-line",
            //   link: "/products/attribute",
            // },
            {
              id: "commisson",
              label: "Commission",
              icon: " ri-file-list-3-line",
              link: "/commissions",
            },
            {
              id: "withdrawrequest",
              label: "Withdraw Request",
              icon: " ri-file-list-3-line",
              link: "/vendor-withdraw",
            },
            {
              id: "sellers",
              label: "Sellers",
              link: "/sellers",
              icon: " ri-file-list-3-line",
            },
          ],
        },

        {
          id: "seller-product-review",
          label: "Product Review",
          icon: "ri-star-line",
          link: "/seller-product-review",
        },
      );
    }

    // Seller menu items - Dashboard and individual product-related options
    if (userRole === "seller") {
      allMenuItems.push(
        {
          id: "seller-profile",
          label: "Profile",
          icon: "ri-user-settings-line",
          link: "/seller/profile",
        },
        {
          id: "products",
          label: "Products",
          icon: "ri-apps-2-line",
          link: "/seller/products",
        },

        {
          id: "category",
          label: "Category",
          icon: "ri-file-list-3-line",
          link: "/seller/products/category",
        },
        {
          id: "subcategory",
          label: "Subcategory",
          icon: "ri-file-list-3-line",
          link: "/seller/products/sub-category",
        },

        {
          id: "orders",
          label: "Orders",
          icon: "ri-shopping-cart-line",
          link: "/seller/orders",
        },
        {
          id: "invoices",
          label: "Invoices",
          icon: "ri-file-text-line",
          link: "/seller/invoices",
        },
        {
          id: "withdrawal",
          label: "Withdrawal",
          icon: "ri-money-dollar-circle-line",
          link: "/seller-draw",
        }
      );
      // Return early for sellers - don't add any other menu items
      return allMenuItems;
    }

    return allMenuItems;
  };

  const menuItems = getFilteredMenuItems();

  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;